import React, {useEffect, useState} from "react";
import "./AbacusPage.sass";
import Window from "../../../_containers/window/Window";
import CircleButton from "../../../_components/common/buttons/CircleButton";
import CloseIcon from "@mui/icons-material/Close";
import {useNavigate} from "react-router";
import {Checkbox, FormControlLabel} from "@mui/material";
import ButtonComponent from "../../../_components/common/buttons/ButtonComponent";
import {TRAINERS_PAGE} from "../../../common/links";

export default function AbacusPage() {
    const initTopState = [false, false, false, false, false, false, false, false];
    const initBottomState = [0, 0, 0, 0, 0, 0, 0, 0];

    const [topValues, setTopValues] = useState(initTopState)
    const [bottomValues, setBottomValues] = useState(initBottomState)
    const [showResult, setShowResult] = useState(true);

    const navigate = useNavigate();

    useEffect(() => {
        document.title = 'КьюАй - Тренажёр Абакус';
    }, [])

    const handleClear = () => {
        setBottomValues(initBottomState)
        setTopValues(initTopState)
    }

    const renderBone = (onClick, key) => {
        return (
            <div key={key} className="Bone-wrapper" onClick={onClick}>
                <div className="Bone-top"></div>
                <div className="Bone-middle"></div>
                <div className="Bone-bottom"></div>
            </div>
        )
    }

    const renderStick = (key) => {
        return (
            <div key={key} className="Abacus-stick"></div>
        )
    }

    const renderTopSector = (value, i) => {
        return <div key={`topSector-${i}`}
                    style={value ? {flexDirection: 'column-reverse'} : {flexDirection: 'column'}}
                    className="Abacus-top-sector">
                {renderBone(() => {
                    const result = [...topValues]
                    result[i] = !result[i]
                    setTopValues(result)
                })}
                {renderStick()}
        </div>
    }

    const renderBottomSector = (value, i) => {
        const onClickHandler = (positiveValue, negativeValue) => {
            const result = [...bottomValues];
            if (bottomValues[i] >= positiveValue) {
                result[i] = negativeValue;
            } else {
                result[i] = positiveValue;
            }
            setBottomValues(result);
        }

        const bones = [
            renderBone(() => {onClickHandler(1, 0)}, `bottom-bone-1-${i}`),
            renderBone(() => {onClickHandler(2, 1)}, `bottom-bone-2-${i}`),
            renderBone(() => {onClickHandler(3, 2)}, `bottom-bone-3-${i}`),
            renderBone(() => {onClickHandler(4, 3)}, `bottom-bone-4-${i}`),
        ]
        bones.splice(bottomValues[i], 0, renderStick(`bottom-stick-${i}`))
        return (
            <div key={`bottomSector-${i}`} className="Abacus-bottom-sector">
                {bones}
            </div>
        )
    }

    return (
        <Window>
            <div className="Abacus-setting">
                <div className="Abacus-title">Абакус</div>
                <div>
                    <CircleButton Icon={CloseIcon} title="Закрыть" onClick={() => navigate(TRAINERS_PAGE)} />
                </div>
            </div>
            <div className="Abacus-button-panel">
                <ButtonComponent onClick={handleClear}>Очистить</ButtonComponent>
                <FormControlLabel control={<Checkbox/>}
                                  checked={showResult}
                                  onChange={() => setShowResult(!showResult)}
                                  label="Показать результат"
                                  labelPlacement="start"/>
            </div>
            {showResult && <div className="Abacus-result">
                <div>{(topValues[0] ? 5 : 0) + bottomValues[0]}</div>
                <div>{(topValues[1] ? 5 : 0) + bottomValues[1]}</div>
                <div>{(topValues[2] ? 5 : 0) + bottomValues[2]}</div>
                <div>{(topValues[3] ? 5 : 0) + bottomValues[3]}</div>
                <div>{(topValues[4] ? 5 : 0) + bottomValues[4]}</div>
                <div>{(topValues[5] ? 5 : 0) + bottomValues[5]}</div>
                <div>{(topValues[6] ? 5 : 0) + bottomValues[6]}</div>
                <div>{(topValues[7] ? 5 : 0) + bottomValues[7]}</div>
            </div>}

            <div className="Abacus-wrapper">
                <div className="Abacus-top">
                    {topValues.map(renderTopSector)}
                </div>
                <div className="Abacus-line"></div>
                <div className="Abacus-bottom">
                    {bottomValues.map(renderBottomSector)}
                </div>
            </div>

        </Window>
    )
}